import * as React from 'react'

import { SimpleTitleButtonHero } from 'sdk/sections'

import aboutHeroVideo from '../../assets/about-hero-video.webm'

export const Hero: React.FC = () => {
  return (
    <SimpleTitleButtonHero
      title="About GPU Audio"
      description="Using the power of GPUs to enhance audio in real-time"
      imageLink="" // Will be overridden by video
      videoLink={aboutHeroVideo}
      alignment="center"
    />
  )
}